const fr = {
  common: {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    phone: 'Téléphone',
    email: 'Email',
    office: 'Bureau',
    availability: 'Disponibilité',
    support: 'Support',
    preOrder: 'Précommande',
    clearForm: 'Effacer le formulaire',
    sending: 'Envoi...',
    select: 'Sélectionner',
    closeNotification: 'Fermer la notification',
  },
  nav: {
    home: 'Accueil',
    about: 'À propos',
    preOrder: 'Précommande',
    contacts: 'Contacts',
    startPreOrder: 'Commencer la précommande',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    logoAria: 'Accueil KUB AUTO',
    languageSwitcher: 'Langue',
  },
  seo: {
    defaultTitle: 'KUB AUTO — Précommande de véhicules premium dans toute l’Europe',
    defaultDescription: 'Sélection, vérification, achat et livraison de véhicules premium dans toute l’Europe avec conditions fixes et sécurité juridique.',
    home: {
      title: 'KUB AUTO — Précommande de véhicules premium dans toute l’Europe',
      description: 'Sélection, vérification, achat et livraison de véhicules premium dans toute l’Europe avec conditions fixes et sécurité juridique.',
    },
    about: {
      title: 'À propos de KUB AUTO — service d’acquisition de véhicules premium',
      description: 'Découvrez comment KUB AUTO organise la recherche, la vérification, la contractualisation, la logistique et la remise de véhicules premium dans toute l’Europe.',
    },
    preOrder: {
      title: 'Formulaire de précommande — envoyez les exigences du véhicule | KUB AUTO',
      description: 'Soumettez vos exigences pour un véhicule premium et recevez des options vérifiées, des conditions claires et un processus contractuel.',
    },
    contacts: {
      title: 'Contacts — conciergerie KUB AUTO',
      description: 'Contactez KUB AUTO via WhatsApp, Telegram ou email pour des consultations sur les véhicules premium et les demandes de précommande.',
    },
  },
  home: {
    gallery: {
      kicker: 'VÉHICULES SÉLECTIONNÉS',
      title: 'De vraies voitures premium issues de commandes récentes',
      sub: 'Une sélection de véhicules réels que nous avons récemment trouvés et livrés. Chaque voiture reflète nos standards élevés en matière de qualité, de contrôle et de service.',
    },
    hero: {
      kicker: 'SERVICE D’ACQUISITION PRIVÉ',
      title: 'Véhicules premium sur précommande individuelle',
      lead: 'Sélection, vérification, achat et livraison dans toute l’Europe — avec conditions fixes et sécurité juridique.',
      cta: 'Commencer la précommande',
      pills: ['Sous contrat', 'Bases officielles', 'Accompagnement complet'],
      cardTitle: 'Ce que vous obtenez',
      badge: 'STANDARD',
      bullets: [
        'Processus documenté et frais fixes',
        'Contrôles techniques et juridiques avant achat',
        'Logistique, douane, certification et remise',
      ],
    },
    process: {
      title: 'Le processus',
      sub: 'Clair, documenté, prévisible.',
      steps: [
        { title: 'Demande', sub: 'Exigences' },
        { title: 'Analyse du marché', sub: 'Sources vérifiées' },
        { title: 'Vérification', sub: 'Juridique + technique' },
        { title: 'Contrat', sub: 'Conditions fixes' },
        { title: 'Livraison', sub: 'Remise' },
      ],
      ctaTitle: 'Soumettez vos exigences — nous revenons avec des options vérifiées',
      ctaText: 'Le délai de recherche habituel est de quelques jours à deux semaines.',
      cta: 'Commencer la précommande',
    },
    trust: {
      title: 'Pourquoi les clients nous font confiance',
      sub: 'Transparence + sécurité juridique pendant toute la transaction.',
      cards: [
        { title: 'Contrat formel', text: 'Frais, étapes et délais fixés.' },
        { title: 'Vérification', text: 'Bases officielles + rapports.' },
        { title: 'Service complet', text: 'Logistique, douane, certification.' },
      ],
      missionTitle: 'Procédure réglementée',
      missionText: 'Sélection → vérification → accord → contrat → achat → livraison → remise. Chaque étape est documentée.',
      cta: 'Obtenir une consultation',
    },
    reviewsFaq: {
      reviewsTitle: 'Avis clients',
      reviewsSub: 'Courts retours de clients qui valorisent la prévisibilité, la clarté et le contrôle.',
      reviews: [
        {
          quote: '« Tout correspondait exactement à ce que nous avions convenu. »',
          text: 'Des étapes claires, des mises à jour régulières et aucune pression. Le prix et le délai sont restés ceux convenus, et la remise s’est déroulée sans problème.',
          meta: 'Andrius Kazlauskas, Vilnius (LT)',
        },
        {
          quote: '« Je savais ce qui se passait à chaque étape. »',
          text: 'Ils ont envoyé des options avec tous les détails, expliqué les points d’attention et géré les documents correctement. Pas d’appels inutiles, seulement une communication claire.',
          meta: 'Nerijus Šimkus, Kaunas (LT)',
        },
        {
          quote: '« La voiture est arrivée exactement comme décrite. »',
          text: 'Les résultats des inspections ont été partagés à l’avance, la logistique a été organisée sans retard et les documents étaient prêts à temps. Au final — un processus professionnel et serein.',
          meta: 'Mārtiņš Pētersons, Riga (LV)',
        },
      ],
      faqTitle: 'FAQ',
      faqSub: 'Réponses aux questions les plus fréquentes sur le processus.',
      faq: [
        { q: 'Comment démarrer une précommande ?', a: 'Soumettez un formulaire de précommande avec vos exigences. Nous confirmons les détails et commençons la recherche.' },
        { q: 'Combien de temps prend la recherche du véhicule ?', a: 'En général de quelques jours à deux semaines, selon la complexité des exigences.' },
        { q: 'Comment les véhicules sont-ils vérifiés ?', a: 'Chaque véhicule fait l’objet d’une vérification technique et juridique à l’aide de bases officielles et de rapports d’inspection.' },
        { q: 'Quand le contrat est-il signé ?', a: 'Après votre validation d’un véhicule précis et l’accord sur toutes les conditions.' },
        { q: 'Quels coûts sont fixés à l’avance ?', a: 'Les frais de service, la logistique, le dédouanement et les frais obligatoires sont fixés dans le contrat.' },
        { q: 'Que se passe-t-il après l’achat du véhicule ?', a: 'Nous organisons la logistique, le dédouanement, la certification et la préparation à la remise.' },
        { q: 'Quand recevrai-je le véhicule ?', a: 'Après la fin de toutes les procédures et la vérification des documents, le véhicule vous est remis.' },
        { q: 'Puis-je refuser un véhicule sélectionné ?', a: 'Oui. La recherche continue jusqu’à validation d’un véhicule correspondant entièrement à vos exigences.' },
        { q: 'Travaillez-vous avec des entreprises ainsi qu’avec des particuliers ?', a: 'Oui. Nous travaillons avec des particuliers et des personnes morales dans le cadre d’un contrat formel.' },
        { q: 'Dans quels pays recherchez-vous des véhicules ?', a: 'Nous recherchons des véhicules dans toute l’Europe, uniquement auprès de fournisseurs et plateformes d’enchères vérifiés.' },
        { q: 'La livraison et le dédouanement sont-ils inclus ?', a: 'Oui. La logistique complète, le dédouanement et la certification font partie de notre service.' },
      ],
    },
    finalCta: {
      kicker: 'PRÊT À COMMENCER',
      title: 'Lancez votre demande de précommande',
      sub: 'Nous répondrons avec des options vérifiées et des conditions claires.',
      cta: 'Accéder à la précommande',
    },
  },
  about: {
    hero: {
      kicker: 'À PROPOS DE L’ENTREPRISE',
      title: 'Véhicules premium acquis sur précommande individuelle dans toute l’Europe',
      lead: 'Nous assurons la sélection, la vérification et l’acquisition professionnelles de véhicules premium selon les demandes individuelles des clients, avec un accompagnement juridique et logistique complet du premier contact à la remise finale.',
      cta: 'Envoyer une demande de précommande',
    },
    overview: {
      title: 'Vue d’ensemble',
      sub: 'Nos services sont conçus pour les clients qui apprécient la transparence, les processus structurés et la sécurité juridique.',
      cards: [
        {
          title: 'Champ d’activité',
          text: 'L’entreprise est spécialisée dans la recherche, la vérification et l’achat de véhicules premium sur le marché européen, y compris auprès de concessionnaires officiels, de fournisseurs vérifiés et de plateformes d’enchères. Toutes les étapes — de la sélection initiale à la remise du véhicule — sont réalisées selon un standard de qualité unifié et des délais convenus.',
        },
        {
          title: 'Accompagnement complet',
          text: 'Nous assurons la sélection du véhicule selon des paramètres définis, une vérification technique et juridique documentée, la fixation du périmètre et du prix dans un contrat, ainsi que l’organisation de l’achat, de la logistique, du dédouanement, de la certification et de la préparation du véhicule à la livraison finale.',
        },
      ],
    },
    principles: {
      title: 'Principes de travail',
      sub: 'Un processus structuré et documenté avec des responsabilités claires à chaque étape.',
      cards: [
        { icon: '✓', title: 'Formalité et transparence', text: 'Toutes les étapes de la coopération et les frais de service sont fixés dans un contrat. Le client comprend clairement le processus, les délais et les obligations de chaque partie.' },
        { icon: '🧾', title: 'Vérification complète du véhicule', text: 'Chaque véhicule fait l’objet d’une vérification technique et juridique via des bases officielles, l’historique d’entretien et, si nécessaire, une inspection indépendante.' },
        { icon: '🎯', title: 'Approche individuelle', text: 'La sélection du véhicule est réalisée strictement selon le budget, les préférences et l’usage prévu par le client — sans offres aléatoires ni inadaptées.' },
        { icon: '🛡', title: 'Accompagnement total', text: 'Nous organisons l’achat, la logistique, le dédouanement, la certification et la préparation du véhicule à la remise, en minimisant les risques et l’implication du client.' },
      ],
    },
    advantages: {
      title: 'Principaux avantages',
      sub: 'Pourquoi les clients choisissent le format de précommande individuelle avec accompagnement professionnel.',
      items: [
        'Expertise confirmée dans le segment des véhicules premium',
        'Coopération exclusivement avec des fournisseurs et plateformes d’enchères vérifiés',
        'Flux de travail clairement structuré et respect strict des délais convenus',
        'Responsabilité du résultat à chaque étape de la transaction',
      ],
    },
    mission: {
      kicker: 'MISSION',
      title: 'Donner accès aux véhicules premium avec qualité garantie et sécurité juridique.',
      text: 'Nous fournissons un service structuré, transparent et professionnel à chaque étape — de la sélection initiale à la remise finale du véhicule avec l’ensemble complet des documents.',
      ctaPrimary: 'Envoyer une demande de précommande',
      ctaSecondary: 'Nous contacter',
    },
    process: {
      title: 'Comment fonctionne le processus de précommande',
      sub: 'Une procédure séquentielle avec des étapes définies et des points de contrôle.',
      steps: [
        { num: '01', title: 'Demande', text: 'Vous transmettez les paramètres du véhicule et vos exigences individuelles.' },
        { num: '02', title: 'Sélection', text: 'Nous recherchons et présentons des options de véhicules vérifiées correspondant à vos critères.' },
        { num: '03', title: 'Contrat', text: 'Toutes les conditions, étapes et frais de service sont fixés contractuellement.' },
        { num: '04', title: 'Achat et logistique', text: 'Nous organisons l’achat, la livraison, le dédouanement et la certification.' },
        { num: '05', title: 'Remise', text: 'Le véhicule est préparé et remis avec un ensemble complet de documents.' },
      ],
      ctaPrimary: 'Envoyer une demande de précommande',
      ctaSecondary: 'Poser une question sur Telegram',
    },
  },
  contacts: {
    hero: {
      kicker: 'CONTACTS',
      title: 'Entrer en contact',
      lead: 'Le moyen le plus rapide : WhatsApp. Nous sommes disponibles 24/7 pour les consultations et les demandes de précommande.',
    },
    primary: {
      title: 'KUB AUTO Concierge',
      emailUs: 'Nous écrire',
      telegramCta: 'Vous préférez Telegram ? Ouvrir le chat →',
    },
    office: {
      label: 'Adresse du bureau',
      address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
      badge: '24/7',
      hoursLabel: 'Horaires',
      hoursValue: '24/7',
      supportLabel: 'Support',
      supportValue: 'WhatsApp / Email',
      preOrderLabel: 'Précommande',
      preOrderValue: 'Processus contractuel',
      openMaps: 'Ouvrir dans Google Maps',
      mapTitle: 'Carte du bureau KUB AUTO',
    },
    form: {
      title: 'Message rapide',
      sub: 'Laissez un court message — nous vous répondrons dès que possible.',
      nameLabel: 'Votre nom',
      namePlaceholder: 'Nom complet',
      emailLabel: 'Email',
      emailPlaceholder: 'name@example.com',
      messageLabel: 'Message',
      messagePlaceholder: 'Quelle voiture recherchez-vous ? Budget, année, kilométrage, préférences...',
      submit: 'Envoyer le message',
      success: 'Message envoyé avec succès. Nous vous répondrons bientôt.',
      error: 'Échec de l’envoi du message.',
    },
  },
  preOrder: {
    hero: {
      kicker: 'FORMULAIRE DE PRÉCOMMANDE',
      title: 'Soumettre les exigences du véhicule',
      lead: 'Nous examinerons votre demande et vous répondrons avec des options vérifiées et des conditions claires.',
    },
    vehicle: {
      title: 'Détails du véhicule',
      sub: 'Paramètres essentiels pour démarrer la sélection.',
      make: 'Marque',
      makePlaceholder: 'ex. BMW',
      model: 'Modèle',
      modelPlaceholder: 'ex. X5',
      year: 'Année',
      yearPlaceholder: 'ex. 2020',
      mileage: 'Kilométrage (km)',
      mileagePlaceholder: 'ex. 45000',
      fuelType: 'Type de carburant',
      bodyType: 'Type de carrosserie',
      preferences: 'Préférences supplémentaires',
      preferencesPlaceholder: 'Finition, couleur, intérieur, état, historique d’utilisation, exigences particulières...',
      fuelOptions: [
        { value: 'petrol', label: 'Essence' },
        { value: 'diesel', label: 'Diesel' },
        { value: 'hybrid', label: 'Hybride' },
        { value: 'electric', label: 'Électrique' },
      ],
      bodyOptions: [
        { value: 'sedan', label: 'Berline' },
        { value: 'wagon', label: 'Break' },
        { value: 'coupe', label: 'Coupé' },
        { value: 'suv', label: 'SUV' },
        { value: 'hatchback', label: 'Hayon' },
        { value: 'other', label: 'Autre' },
      ],
    },
    buyer: {
      title: 'Informations sur l’acheteur',
      sub: 'Pour le contrat et la communication.',
      buyerType: 'Type d’acheteur',
      buyerTypeOptions: [
        { value: 'individual', label: 'Particulier' },
        { value: 'company', label: 'Entreprise' },
      ],
      buyerName: 'Nom / Société',
      buyerNamePlaceholder: 'Nom complet ou entité juridique',
      address: 'Adresse',
      addressPlaceholder: 'Rue, ville, pays',
      phone: 'Téléphone',
      phonePlaceholder: '+370 688 03122',
      email: 'Email',
      emailPlaceholder: 'name@example.com',
      submit: 'Envoyer la demande',
      askWhatsapp: 'Demander sur WhatsApp',
      askTelegram: 'Demander sur Telegram',
      success: 'Demande envoyée avec succès. Nous vous contacterons bientôt.',
      error: 'Échec de l’envoi de la demande.',
    },
    validation: {
      required: 'Obligatoire',
      yearFormat: 'Utilisez 4 chiffres (ex. 2020)',
      numbersOnly: 'Chiffres uniquement',
      tooLong: 'Trop long',
      invalidPhone: 'Utilisez le format international, ex. +37068803122',
      invalidEmail: 'Email invalide',
      invalid: 'Invalide',
    },
  },
  validation: {
    tooShort: 'Trop court',
    tooLong: 'Trop long',
    required: 'Obligatoire',
    invalidEmail: 'Email invalide',
    invalid: 'Invalide',
    unknownError: 'Erreur inconnue',
  },
};

export default fr;
